import { render } from "./PetRow.vue?vue&type=template&id=6b0cfe3a&scoped=true"
import script from "./PetRow.vue?vue&type=script&lang=js"
export * from "./PetRow.vue?vue&type=script&lang=js"

import "./PetRow.vue?vue&type=style&index=0&id=6b0cfe3a&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0cfe3a"]])

export default __exports__